import { isProgramsEnabled } from "@/services/config";

const administrationRoutes = [
  {
    path: "/administration",
    name: "administration",
    meta: { enabled: isProgramsEnabled },
    component: () =>
      import(
        /* webpackChunkName: "administration" */ "../components/administration/Administration.vue"
      ),
  },
  {
    path: "/administration/history",
    name: "administration-history",
    meta: { enabled: isProgramsEnabled },
    component: () =>
      import(
        /* webpackChunkName: "administration" */ "../components/administration/AdministrationHistory.vue"
      ),
  },
];

export default administrationRoutes;
